var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"network-page"}},[_c('h1',[_vm._v(_vm._s(_vm.$i18n.t('pages.network.title')))]),_c('network-setup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }